import Swiper from 'swiper';
import 'bootstrap';
import AOS from 'aos';
import modaal from 'modaal';
import enquire from 'enquire.js';
import ScrollMagic from 'scrollmagic';

require('./style.scss');

window.addEventListener('DOMContentLoaded', () => {
	// $(function () { // wait for document ready
	// 	// init
	// 	var controller = new ScrollMagic.Controller({
	// 		globalSceneOptions: {
	// 			triggerHook: 'onLeave'
	// 		}
	// 	});
	//
	// 	// get all slides
	// 	var slides = document.querySelectorAll("section.home-section");
	//
	// 	// create scene for every slide
	// 	for (var i=0; i<slides.length; i++) {
	// 		new ScrollMagic.Scene({
	// 			triggerElement: slides[i]
	// 		})
	// 			.setPin(slides[i])
	// 			.addIndicators() // add indicators (requires plugin)
	// 			.addTo(controller);
	// 	}
	// });
});

window.addEventListener('DOMContentLoaded', () => {
	$('.new-menu').modaal({
		content_source: '#new-menu',
		fullscreen: true,
		background_scroll: false,
		loading_content: "Loading &hellip;",
		animation: "fade"
	});
});


/**
 * Product page: click on values to display modal
 */
window.addEventListener('DOMContentLoaded', () => {
	enquire.register("screen and (min-width:576px)", function(){
		$('.product-value__badge').modaal({
			type: 'ajax',
			width: 1300,
			background_scroll: false,
			loading_content: "Loading &hellip;",
			animation: "fade"
		});
	});
	enquire.register("screen and (max-width:576px)", function(){
		$('.product-value__badge').modaal({
			type: 'ajax',
			fullscreen: true,
			background_scroll: false,
			loading_content: "Loading &hellip;"
		});
	});
});

/**
 * Toggle values on product page
 */
window.addEventListener('DOMContentLoaded', () => {

	$('.product-value__badge').hover(function(){
		var value = $(this).attr("data-value");
		$('.product-section__values-backdrop').toggleClass(value);
		$('.product-section__values-backdrop').toggleClass('open');
	});
});

window.addEventListener('DOMContentLoaded', () => {

	AOS.init();

	// product image carousel
	var productGallery = new Swiper('.product-gallery', {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true,
		centeredSlides: true,
		pagination: {
			el: '.swiper-pagination'
		},
	});

	// product lifestyle image carousel
	var lifestyleGallery = new Swiper('.lifestyle-gallery', {
		slidesPerView: 'auto',
		spaceBetween: 20,
		autoHeight: true,
		loop: true,
		lazy: true,
		centeredSlides: true,
		pagination: {
			el: '.swiper-pagination',
		},
		breakpoints: {
			1024: {
				slidesPerView: 1,
			  	spaceBetween: 10,
			},
			768: {
			  	slidesPerView: 1,
			  	spaceBetween: 0,
			},
			640: {
			  	slidesPerView: 1,
			  	spaceBetween: 0,
			},
			320: {
			  	slidesPerView: 1,
				spaceBetween: 0,
			}
		}
	});

	// We checking cookie for geolocalisation
	var cookie = getCookie('geopopup-state');

	if( getURLParameter('showgeopopup') == 1 )
		cookie = '';

	if( cookie == '' ){
		$.ajax({
	      	url: 'https://freegeoip.app/json/',
	      	type:'GET',
	      	success: function(data){
	      		// console.log('success');
	      		$('#geoPopupModal #detectedCountry').html( data.country_code );
	      		$('#geoPopupModal').modal('show');
	      		setCookie('geopopup-state','closed');
	      	},
	      	error: function(data){
	      		// console.log('error');
	      	},
	      	complete: function(data){
	      		// console.log('complete');
	      	}
	    });
    }

    // MENU
    $( "#menu .first-menu-bloc .main-nav a" ).mouseover(function() {

    	var parentElement = $(this).parent();
    	var actifShopMenu;

    	// first element SHOP
    	if( $('li').index(parentElement) == 0 ){

    		actifShopMenu = true;
    		$('.second-menu-bloc').addClass('active');
    		$('#menu .second-menu-bloc').css('background-image', 'none');
    		$('#menu .second-menu-bloc .main-nav').show();

    	}else{

    		actifShopMenu = false;
    		$('#menu .second-menu-bloc .main-nav').hide();

    	}

    	if(actifShopMenu){

    		$('.second-menu-bloc').addClass('active');
    		$('#menu .second-menu-bloc').attr('style','background-image:none');
    		$('#menu .second-menu-bloc .main-nav').show();
    		$('#menu .first-menu-bloc .main-nav li').eq(0).addClass('active');

    	}else{

    		$('#menu .first-menu-bloc .main-nav li').eq(0).removeClass('active');

    	}

  		switch($(this).attr('href')) {
		  	case '/pages/contact':
		    	$('#menu .second-menu-bloc').css('background-image', 'url(https://cdn.accentuate.io/1623288905772/6263638360108/WDS_BikeRE_2144.jpg?1200x800)');
		    	break;
		    case '/pages/find-a-store':
		    	$('#menu .second-menu-bloc').css('background-image', 'url(https://cdn.shopify.com/s/files/1/0038/0495/4739/files/darion-queen-1270656-unsplash.jpg?2189368792960650129)');
		    	break;
		    default:
		    	//$('#menu .second-menu-bloc').css('background-image', 'url(https://cdn.shopify.com/s/files/1/0038/0495/4739/files/pre_launch_contemporary.jpg?13857489194663106178)');
		}
	});

});

$(function () {

	// show color swatch toolips
	$('[data-toggle="tooltip"]').tooltip()
	
	//  toggle menu
	jQuery('.toggle-menu').click(function(){
		$(this).toggleClass('active');
		$('#menu').toggleClass('open');
		$('body').toggleClass('overflow-hidden');
	})

	// click for the submenu
	$('#menu .mobile-menu a').click(function(){
		$('*[data-ssmenu="'+$(this).data('menu-mobile')+'"]').css('left','0');
	})

	// click back submenu
	$('#menu .mobile-smenu').on('click','.arrow-back',function() {
		var ssmneu = $(this).closest('.mobile-smenu').data('ssmenu');
		$('*[data-ssmenu="'+ssmneu+'"]').css('left','-200%');
	})

})

function getCookie(cname) {
  	var name = cname + "=";
  	var decodedCookie = decodeURIComponent(document.cookie);
  	var ca = decodedCookie.split(';');
  	for(var i = 0; i <ca.length; i++) {
    	var c = ca[i];
    	while (c.charAt(0) == ' ') {
      		c = c.substring(1);
    	}
    	if (c.indexOf(name) == 0) {
      	return c.substring(name.length, c.length);
    	}
  	}
  	return '';
}

function setCookie(cname, cvalue, exdays) {
  	var d = new Date();
  	if( exdays != '' )
  		d.setTime(d.getTime() + (exdays*24*60*60*1000));
  	var expires = "expires="+ d.toUTCString();
  	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getURLParameter(sParam){
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++){
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam){
            return sParameterName[1];
        }
    }
}

function getGeoLocation(){

	// https://ipstack.com/
	// NEED NEXT PLAN?

	// var ip = '14.1.51.50'
	// var access_key = 'cc3aa58e6a6bc217cc80bf628c10c036';
	// $.ajax({
	//   	url: 'http://api.ipstack.com/' + ip + '?access_key=' + access_key,
	//   	type:'GET',
	//   	success: function(json) {
	//     	console.log(json);
	//   	}
	// });

}

$(function () {

	/// Main search input
	// $('#menu-search .search-box input[type="text"]').bind('focusin focusout', function(e){
	//     $(this).closest('.search-box').toggleClass('focus', e.type == 'focusin');
	// });

	var searchTimeoutThrottle = 500;
	var searchTimeoutID = -1;
	var currReqObj = null;
	var $resultsBox;

	//$('#menu-search .search-box input[type="text"]').bind('keyup change', function(){
	$('.ajax-form-search input[type="text"]').bind('keyup change', function(){

		//Only search if search string longer than 2, and it has changed
		if($(this).val().length > 2 && $(this).val() != $(this).data('oldval')) {
			//Reset previous value
			$(this).data('oldval', $(this).val());

			// Kill outstanding ajax request
			if(currReqObj != null) currReqObj.abort();

			// Kill previous search
			clearTimeout(searchTimeoutID);

			var $form = $(this).closest('form');

			//Search term
			var term = '*' + $form.find('input[name="q"]').val() + '*';

			//URL for full search page
			//var linkURL = $form.attr('action') + '?q=' + term;
			//var linkURL = $form.attr('action') + '?type=product&q=' + term;
			var linkURL = $form.attr('action') + '?q=' + term;

			//Show loading
			$resultsBox.html('<div class="load text-center mb-2 mt-2 w-100"><i class="fas fa-spinner "></i></div>');

			// Do next search (in X milliseconds)
			searchTimeoutID = setTimeout(function(){

				//Ajax hit on search page
				currReqObj = $.ajax({
					url: $form.attr('action'),
					data: {
						//type: 'product',
						view: 'json',
						q: term,
					},
					dataType: "json",
					success: function(data){
						currReqObj = null;
						if(data.results_total == 0) {
							//No results
							//$resultsBox.html('<div class="note">'+  layout.live_search.no_results | t | json  +'</div>');
							$resultsBox.html('<div>no result</div>');
						} else {
							//Numerous results
							$resultsBox.empty();
							$.each(data.results, function(index, item){
								//var xshow = 'wholesale'; //term for products we dont want to show
								//if(!(item.title.toLowerCase().indexOf(xshow) > -1)) {
								var $row = $('<a></a>').attr('href', item.url);
								$row.append('<div class="d-title">'+item.title+'</div>');
								$resultsBox.append($row);
								//}
							});
							$resultsBox.append('<a href="' + linkURL + '" class="note">see all</a>');
						}
					}
				});

			}, searchTimeoutThrottle);
		} else if ($(this).val().length <= 2) {
			//Deleted text? Clear results
			$resultsBox.empty();
		}

	}).attr('autocomplete', 'off').data('oldval', '').bind('focusin', function(){

		$resultsBox = $('<div class="results-box text-left position-absolute w-100 mt-2" />').appendTo( $(this).closest('.ajax-form-search') );

		//Focus, show results
		$resultsBox.fadeIn(200);

	}).bind('click', function(e){

		//Click, prevent body from receiving click event
		e.stopPropagation();

	});

	// $('body').bind('click', function(){
	//Click anywhere on page, hide results
	// $resultsBox.fadeOut(200);
	// });

	//Search box should mimic live search string: products only, partial match
	// $('.search-form, #search-form').on('submit', function(e){
	//   	e.preventDefault();
	//   	var term = '*' + $(this).find('input[name="q"]').val() + '*';
	//   	var linkURL = $(this).attr('action') + '?type=product&q=' + term;
	//   	window.location = linkURL;
	// });

	// search ends
});

$(function () {
	//  toggle search
	jQuery('.toggle-search').click(function(){
		$(this).toggleClass('active-search');
		$('#menu-search').toggleClass('open');
		$('body').toggleClass('overflow-hidden');
		$(this)
			.find('[data-fa-i2svg]')
			.toggleClass('fa-search')
			.toggleClass('fa-times');
		if( $('#menu-search').hasClass('open') ){
			setTimeout(function(){
				$('.ajax-form-search input[type="text"]').focus();
			},100);
		}
	})
});

